import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import './SegmentList.scss';
import BaseListContainer from '../../base/BaseListContainer';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import DeletePrompt from '../../../components/base/DeletePrompt';
import AuthButton from '../../../components/base/AuthButton';
import { NavBarNames } from '../../../config/NavBarNameList';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import UpdateRecencyFrequencyMonetaryScoreSetting from './UpdateRecencyFrequencyMonetaryScoreSetting';
import AuthButtonWithDropdown from 'components/base/AuthButtonWithDropdown';
import { CUSTOMER_GROUP_TEMPLATE_FILE_PATH } from 'services/CustomerGroupApiHelper';
import { createAction } from 'utils';
import { ImportResource } from 'models/DownloadImportModel';
import Filter from './Filter';


const SEGMENT_LIST_TAB = {
  SEGMENTS: "List of Segments",
  BLACKLIST_SEGMENTS: "List of Blacklist Segment",
}

function SegmentList() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const hiddenFileInput = React.useRef(null);

  const [showScoreSetting, setShowScoreSetting] = useState(false);
  const [uploadOriginFileName, setUploadOriginFileName] = useState();

  const {
    listFields,
    dataList,
    pageInfo,
    totalPage,
    totalCount,
    checkedList,
    importedFile,
  } = useSelector((state) => ({
    listFields: state.segments.listDisplayFields,
    dataList: state.segments.segmentList,
    pageInfo: state.segments.pageInfo,
    totalPage: state.segments.totalPage,
    totalCount: state.segments.totalCount,
    checkedList: state.segments.checkedList,
    importedFile: state.uploadFiles.importedFile,
  }));

  const handleDownloadImportForm = () => {
    var eleLink = document.createElement('a');
    eleLink.href = CUSTOMER_GROUP_TEMPLATE_FILE_PATH;
    eleLink.style.display = 'none';
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }

  const handleImportStaticSegment = (event) => {
    const fileUploaded = event.target.files[0];
    setUploadOriginFileName(fileUploaded?.name);
    dispatch(
      createAction('uploadFiles/uploadFile')({
        file: fileUploaded,
        source: event,
      }),
    );

    event.target.value = null;
  };
  useEffect(() => {
    if (Object.keys(importedFile).length) {
      dispatch({
        type: 'downloadAndImport/importFile',
        payload: {
          from: ImportResource.customerGroup,
          file: importedFile,
          related: {
            fileName: uploadOriginFileName,
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, importedFile]);

  const buttons = [
    <AuthButton
      title={'Edit RFM Score Setting'}
      className="btn-back-button-common btn-download"
      action={() => {
        setShowScoreSetting(true);
      }}
      requires={PermissionCodes.changeSegment}
    />,
    <AuthButtonWithDropdown
      className="btn-download"
      permissionRequires={PermissionCodes.addImportjob}
      title={'Import'}
      options={[
        {
          title: "Create Static Segment by Import",
          action: () => { hiddenFileInput.current.click(); },
        },
        {
          title: "Download Import Form",
          action: handleDownloadImportForm,
        },
      ]}
    />,
    <input
      type="file"
      ref={hiddenFileInput}
      onChange={handleImportStaticSegment}
      style={{ display: 'none' }}
      accept=".csv"
    />,
    <AuthButton
      title={'Create Segment'}
      className="btn-further"
      action={() => {
        // dispatch({ type: 'earningRuleList/clearData' });
        history.push({
          pathname: '/segments/create/',
        });
      }}
      requires={PermissionCodes.changeSegment}
    />,
  ];

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        // setShowPrompt(true);
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.deleteSegment,
    },
  ];

  const tabs = [
    // {
    //   name: 'Overview',
    //   content: <div>Overview</div>,
    // },
    {
      name: SEGMENT_LIST_TAB.SEGMENTS,
      content: (
        <BaseTabListContainer
          showLastUpdateTime
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{ hasFilter: true, component: Filter }}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'segments'}
              hasOtherActions={false}
              permissionGroup={PermissionCodes.segment}
              deleteInfo={{
                data: [],
                title: 'segments',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.SEGMENT,
              }}
              actions={['Detail', 'Edit', 'Delete', 'Duplicate']}
            />
          }
        />
      ),
    },
    {
      name: SEGMENT_LIST_TAB.BLACKLIST_SEGMENTS,
      content: (
        <BaseTabListContainer
          showLastUpdateTime
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{ hasFilter: true, component: Filter }}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'segments'}
              hasOtherActions={false}
              permissionGroup={PermissionCodes.segment}
              deleteInfo={{
                data: [],
                title: 'segments',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.SEGMENT,
              }}
              actions={['Detail', 'Edit', 'Delete', 'Duplicate']}
            />
          }
        />
      ),
    },
  ];

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    dispatch({ type: 'segments/clearData' });
  }, [dispatch]);

  useEffect(() => {
    const queryString = require('query-string');
    if (queryString) {
      const searchDict = queryString.parse(location.search);
      const searchKey = queryString.parse(location.search)['search'];
      const stringRank = queryString.parse(location.search)['rank'];
      const stringPage = queryString.parse(location.search)['page'] || 1;
      const rank = stringRank === 'true';
      const page = parseInt(stringPage);
      const isBlacklist = activeTab === SEGMENT_LIST_TAB.BLACKLIST_SEGMENTS
      dispatch({
        type: 'segments/getSegmentsList',
        payload: {
          page,
          reverse: rank,
          type: '',
          search: searchKey,
          moreSearch: {
            ...searchDict,
            isBlacklist,
            showInCustomerProfile: searchDict?.show_in_customer_profile
           },
        }
      });
    }
  }, [dispatch, location, activeTab]);

  return (
    <>
      <CustomListComponent
        caution={{
          detail: (
            <div>
              {'2 type segment'}
              <ul>
                <li>
                  {'Dynamic segment is a dynamic segment is a customer list that is managed by the system and automatically updated. With each update, customers who meet specific criteria will be added to the list, while those who no longer fulfill these criteria will be removed.'}
                </li>
                <li>
                  {'Static segment consists of a group of customers that is managed manually. This group will not receive automatic updates.'}
                </li>
              </ul>
            </div>
          ),
          title: NavBarNames.segments,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={false}
        onTabChange={(key) => {
          setActiveTab(key);
          //   let search = '';
          //   if (key !== 'Overview') {
          //     // search = queryString.stringify({
          //     //   [URLFilterKeys.type]: CampaignType.allTypes,
          //     //   [URLFilterKeys.page]: 1,
          //     //   [URLFilterKeys.searchKey]: '',
          //     //   [URLFilterKeys.rank]: true,
          //     // });
          //   }
          //   history.push({ pathname: '/customer', hash: key, search: search });
        }}
      />
      <DeletePrompt
        data={checkedList}
        title={'segments'}
        relatedName={''}
        relatedSections={DELETE_RELATED_SECTIONS.SEGMENT}
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch({
            type: 'segments/delete',
            payload: {
              afterAction: () => {
                history.push(location);
              },
            }
          });
        }}
      />
      <UpdateRecencyFrequencyMonetaryScoreSetting
        show={showScoreSetting}
        setShow={setShowScoreSetting}
      />
    </>
  );
}

export default SegmentList;
